@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.edit-preset-body {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  padding: @space-16;
  color: var(--default--text-color--17);
  font-size: 14px;
}

.remove-option-button {
  height: 30px;
  margin-top: 25px;
}

.name-hotkey-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: @space-24;
}

.preset-name-field {
  flex: 1;
}

.hotkey-field {
  width: 120px;
}

.hotkey-dropdown-toggler {
  height: 32px;
}

.error-message-container {
  width: 375px;
}

.available-options-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: @space-4;
}

.available-options-button {
  height: 24px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  padding: 0 @space-4;
}

.option-divider {
  height: 24px;
  border-color: var(--default--border-color--10);
}

.added-preset-container {
  width: 100%;
  display: flex;
  gap: @space-8;
}

.added-preset-content {
  flex: 1;
}

.close-button {
  align-self: flex-end;
  margin-bottom: @space-4;
}
